export const DEVELOPER_LIST_REQUEST   = 'DEVELOPER_LIST_REQUEST'
export const DEVELOPER_LIST_SUCCESS   = 'DEVELOPER_LIST_SUCCESS'
export const DEVELOPER_LIST_FAIL      = 'DEVELOPER_LIST_FAIL'